import { trackEvent } from '../../lib/analytics'
import { BLOG_POSTS, formatBlogDate } from '../../lib/blogManifest'
import { useCommonT } from '../../i18n'

/**
 * Newest blog posts, both home states. Cards are plain <a> anchors, NOT
 * router Links: /blog is prerendered static HTML outside the SPA, and a
 * router Link would client-navigate into the catch-all route instead
 * (same rule as Footer.tsx).
 */
const MAX_CARDS = 3

export default function BlogRow() {
  const t = useCommonT()
  const posts = BLOG_POSTS.slice(0, MAX_CARDS)
  if (posts.length === 0) return null
  return (
    <section className="space-y-4 text-left">
      <div className="flex items-baseline justify-between">
        <h2 className="text-xs font-semibold uppercase tracking-wide text-gray-400">{t('home.blog')}</h2>
        <a href="/blog" className="text-xs font-medium text-purple-300 hover:text-purple-200 transition-colors">
          {t('home.all_posts')} <span aria-hidden>&rarr;</span>
        </a>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {posts.map((post) => (
          <a
            key={post.slug}
            href={`/blog/${post.slug}`}
            onClick={() => trackEvent('home_blog_card_clicked', { slug: post.slug })}
            className="surface surface-interactive overflow-hidden flex flex-col"
          >
            {post.hero && (
              <img src={post.hero} alt={post.heroAlt ?? ''} loading="lazy" className="h-32 w-full object-cover" />
            )}
            <span className="p-4 space-y-1.5 flex-1 flex flex-col">
              <span className="block text-[15px] font-semibold text-white leading-snug">{post.title}</span>
              <span className="block text-[13px] text-gray-400 leading-snug flex-1">{post.description}</span>
              <span className="block text-xs text-gray-500 pt-1">{formatBlogDate(post.date)}</span>
            </span>
          </a>
        ))}
      </div>
    </section>
  )
}
